'use client';

import { useLayoutEffect } from 'react';
import { useIsMobileAppArticle } from '@/app_lib/hooks/useIsMobileAppArticle';

const STICKY_BELOW_ADS_VAR = '--article-sticky-below-ads-offset';
const PROGRESS_GAP_VAR = '--article-progress-bar-under-header-gap';

/** Syncs sticky `top` offsets with HideOnMobileAppArticle (header not rendered in the app WebView). */
export const MobileAppArticleStickyLayoutVars = () => {
  const isMobileAppArticle = useIsMobileAppArticle();

  useLayoutEffect(() => {
    const root = document.documentElement;
    if (isMobileAppArticle) {
      root.style.setProperty(STICKY_BELOW_ADS_VAR, '0px');
      root.style.setProperty(PROGRESS_GAP_VAR, '0px');
    } else {
      root.style.removeProperty(STICKY_BELOW_ADS_VAR);
      root.style.removeProperty(PROGRESS_GAP_VAR);
    }
    return () => {
      root.style.removeProperty(STICKY_BELOW_ADS_VAR);
      root.style.removeProperty(PROGRESS_GAP_VAR);
    };
  }, [isMobileAppArticle]);

  return null;
};
